export default __webpack_public_path__ + "static/media/3435 spice rack B top.628bb507.png";